import { getTextField } from '@lender/utils';
import { object } from 'yup';

export const schema = object().shape({
  feeEscalationId: getTextField(),
});
